import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, unitTypes, dropdowns, service } from "./../data";

export default AddEditPanelContainer(AddEditPanel, {
    pickLists,
    unitTypes,
    dropdowns,
    service,
});
